import {getActivePinia, acceptHMRUpdate, defineStore} from 'pinia';

export const useSessionStore = defineStore('session', {

  state: () => ({
    currentUser: null,
    userStoreInfo: null,
    deleteBinSummary: null,
    deleteBinSummaryText: null,
    isTogglingImpersonation: false
  }),

  actions: {
    async signUp({name, email, password, referralSource}) {
      const user = await useSessionApi().signUp({name, email, password, referralSource});
      this.currentUser = mapCurrentUser(user);
      return this.currentUser;
    },

    resetAllStores() {
      //todo revisit later, fra-gi-le: https://github.com/vuejs/pinia/discussions/1859
      getActivePinia()._s.forEach(item => item.$reset());
    },

    async getCurrentUser() {
      let user;

      user = await useSessionApi().getCurrentUser();
      this.currentUser = mapCurrentUser(user);

      return user;
    },

    async updateCurrentUser(user) {
      const updatedUser = await useSessionApi().updateCurrentUser(user);
      this.currentUser = Object.assign(this.currentUser, mapCurrentUser(updatedUser));
      return this.currentUser;
    },

    async getUserStoreInfo() {
      const info = await useSessionApi().getUserStoreInfo({bypassAuth: !this.isAuthenticated});
      this.userStoreInfo = info;
      return info;
    },

    async getDeleteBinSummary() {
      const summary = await useSessionApi().getDeleteBinSummary();
      this.deleteBinSummary = summary;
      this.deleteBinSummaryText = `${summary.count} item${summary.count !== 1 ? 's' : ''}`;
      return summary;
    },

    async toggleImpersonate({id}) {
      this.isTogglingImpersonation = true;

      try {
        await useSessionApi()[id ? 'startImpersonate' : 'stopImpersonate']({id});
        await useTokenRefresh().refreshToken();
        this.resetAllStores();
        clearHomeCache();
        // resetAllStores() just $reset() this store too, which wiped the flag above.
        this.isTogglingImpersonation = true;
        const user = await useSessionApi().getCurrentUser();
        this.currentUser = mapCurrentUser(user);
      } finally {
        this.isTogglingImpersonation = false;
      }
    },

    // Detects auth cookie changes made outside this tab (e.g. impersonation toggled
    // in another tab) and reloads to pick up the new identity cleanly. Skipped while
    // this tab is mid-toggle itself, so it can't race that flow's own navigation.
    async resyncIfChanged() {
      if (this.isTogglingImpersonation) return false;

      const user = await useSessionApi().getCurrentUser();
      const changed = user.id !== this.currentUser?.id || Boolean(user.impersonator) !== Boolean(this.currentUser?.impersonator);

      if (changed) {
        window.location.reload();
      }

      return changed;
    }
  },

  getters: {
    isAuthenticated: state => Boolean(state.currentUser),
    currentUserId: state => state.currentUser?.id,
    isImpersonating: state => Boolean(state.currentUser?.impersonator),
    isAdmin: state => Boolean(state.currentUser?.isAdmin)
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSessionStore, import.meta.hot));
}
